import React, { useState, useEffect } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase_setup/firebase";
import { Container, Row, Col } from "react-grid-system";
import {
  Button,
  Card,
  Label,
  TextInput,
  Checkbox,
  Modal,
} from "flowbite-react";
import HeaderBar from "./components/Header";
import ToastMSG from "./components/Toast";
import { ToastErrMSG } from "./components/Toast";
import ButtonMui from "@mui/material/Button";
import { Datepicker, WeekStart } from "flowbite-react";

function AddCalendarComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { action, id } = location.state || { action: "nuevo", id: null };
  const isEdit = action === "editar";

  const [calendars, setCalendars] = useState([]);
  const [selectedCalendarId, setSelectedCalendarId] = useState(id || "");
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState("00:00");
  const [endDate, setEndDate] = useState("00:00");
  const [lunes, setLunes] = useState(false);
  const [martes, setMartes] = useState(false);
  const [miercoles, setMiercoles] = useState(false);
  const [jueves, setJueves] = useState(false);
  const [viernes, setViernes] = useState(false);
  const [sabado, setSabado] = useState(false);
  const [domingo, setDomingo] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [UnabledDays, setUnabledDays] = useState([]);
  const [UnabledSlots, setUnabledSlots] = useState([]);
  const [showFestivityForm, setShowFestivityForm] = useState(false);
  const [showSlotsForm, setSlotsForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Cargar calendarios existentes
  useEffect(() => {
    const fetchCalendars = async () => {
      const q = query(collection(db, "Calendars"));
      const data = await getDocs(q);
      const calendarsList = data.docs.map((d) => ({ id: d.id, ...d.data() }));
      setCalendars(calendarsList);

      if (isEdit && id) {
        const cal = calendarsList.find((c) => c.id === id);
        if (cal) {
          setSelectedCalendarId(cal.id);
          setName(cal.CalendarID);
          setStartDate(
            cal.StartTime
              ? new Date(cal.StartTime).toLocaleTimeString("es-ES", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "00:00",
          );
          setEndDate(
            cal.EndTime
              ? new Date(cal.EndTime).toLocaleTimeString("es-ES", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "00:00",
          );
          const wd = cal.WeekDays || {};
          setLunes(wd.L || false);
          setMartes(wd.M || false);
          setMiercoles(wd.X || false);
          setJueves(wd.J || false);
          setViernes(wd.V || false);
          setSabado(wd.S || false);
          setDomingo(wd.D || false);
          setUnabledDays(cal.UnabledDays || []);
          setUnabledSlots(cal.UnabledSlots || []);
          setShowFestivityForm(cal.UnabledDays && cal.UnabledDays.length > 0);
          setSlotsForm(cal.UnabledSlots && cal.UnabledSlots.length > 0);
        }
      }
    };
    fetchCalendars();
  }, [isEdit, id]);

  const normalizeCalendarData = (days, slots) => {
    const cleanDays = days
      .filter((d) => d.Title && !d.Deleted)
      .map((d) => ({
        Title: d.Title,
        Date:
          d.Date instanceof Date
            ? d.Date
            : d.Date?.seconds
              ? d.Date.toDate()
              : new Date(d.Date),
      }));

    const cleanSlots = slots
      .filter((s) => !s.Deleted && (s.Why || s.StartTime || s.EndTime))
      .map((s) => ({
        Why: s.Why,
        StartTime:
          s.StartTime instanceof Date
            ? s.StartTime
            : s.StartTime?.seconds
              ? s.StartTime.toDate()
              : new Date(s.StartTime),
        EndTime:
          s.EndTime instanceof Date
            ? s.EndTime
            : s.EndTime?.seconds
              ? s.EndTime.toDate()
              : new Date(s.EndTime),
      }));

    return { cleanDays, cleanSlots };
  };

  const handleNameChange = (value) => {
    setName(value);
    if (!isEdit) return;
    const cal = calendars.find((c) => c.CalendarID === value);
    if (isEdit) {
      if (!value) {
        clearForm();
        setSelectedCalendarId(null);
      } else if (cal) {
        setSelectedCalendarId(cal.id);
        const startDateValue = cal.StartTime
          ? `${cal.StartTime.toDate()
              .getHours()
              .toString()
              .padStart(2, "0")}:${cal.StartTime.toDate()
              .getMinutes()
              .toString()
              .padStart(2, "0")}`
          : "00:00";

        const endDateValue = cal.EndTime
          ? `${cal.EndTime.toDate()
              .getHours()
              .toString()
              .padStart(2, "0")}:${cal.EndTime.toDate()
              .getMinutes()
              .toString()
              .padStart(2, "0")}`
          : "00:00";

        setStartDate(startDateValue);
        setEndDate(endDateValue);
        const wd = cal.WeekDays || {};
        setLunes(wd.L || false);
        setMartes(wd.M || false);
        setMiercoles(wd.X || false);
        setJueves(wd.J || false);
        setViernes(wd.V || false);
        setSabado(wd.S || false);
        setDomingo(wd.D || false);
        setUnabledDays(
          (cal.UnabledDays || []).map((f) => ({
            ...f,
            Date: f.Date
              ? new Date(f.Date.seconds ? f.Date.toDate() : f.Date)
              : new Date(),
          })),
        );

        setUnabledSlots(
          (cal.UnabledSlots || []).map((s) => ({
            ...s,
            StartTime: s.StartTime
              ? s.StartTime.seconds
                ? s.StartTime.toDate()
                : new Date(s.StartTime)
              : null,
            EndTime: s.EndTime
              ? s.EndTime.seconds
                ? s.EndTime.toDate()
                : new Date(s.EndTime)
              : null,
          })),
        );

        setShowFestivityForm(cal.UnabledDays && cal.UnabledDays.length > 0);
        setSlotsForm(cal.UnabledSlots && cal.UnabledSlots.length > 0);
      }
    } else {
      setSelectedCalendarId(null);
      setStartDate("00:00");
      setEndDate("00:00");
      setUnabledDays([]);
      setUnabledSlots([]);
      setShowFestivityForm(false);
      setSlotsForm(false);
    }
  };

  const clearForm = () => {
    setName("");
    setStartDate("00:00");
    setEndDate("00:00");
    setLunes(false);
    setMartes(false);
    setMiercoles(false);
    setJueves(false);
    setViernes(false);
    setSabado(false);
    setDomingo(false);
    setUnabledDays([]);
    setUnabledSlots([]);
    setShowFestivityForm(false);
    setSlotsForm(false);
  };

  const saveCalendar = async () => {
    let cpUnabledDays = [].concat(UnabledDays);
    cpUnabledDays = cpUnabledDays.filter((u) => u.Title != "" && !u.Deleted);
    cpUnabledDays.forEach((u) => {
      let date = new Date();
      date.setHours(0, 0, 0, 0);
      if (u.Date == "") u.Date = date;

      delete u.id;
      delete u.Deleted;
    });
    let cpUnabledSlots = [].concat(UnabledSlots);
    cpUnabledSlots = cpUnabledSlots
      .filter((u) => !u.Deleted)
      .filter((u) => u.Why || u.StartTime || u.EndTime);
    cpUnabledSlots.forEach((u) => {
      delete u.id;
      delete u.Deleted;
    });
    if (!name || !startDate || !endDate) {
      setMessage("ERROR: Complete todos los campos");
      setStatus("failure");
      return;
    }
    const weekDays = {
      L: lunes,
      M: martes,
      X: miercoles,
      J: jueves,
      V: viernes,
      S: sabado,
      D: domingo,
    };
    try {
      const fechaInicio = new Date();
      const [hI, mI] = startDate.split(":");
      fechaInicio.setHours(parseInt(hI), parseInt(mI), 0, 0);
      const fechaFin = new Date();
      const [hF, mF] = endDate.split(":");
      fechaFin.setHours(parseInt(hF), parseInt(mF), 0, 0);
      const { cleanDays, cleanSlots } = normalizeCalendarData(
        cpUnabledDays,
        cpUnabledSlots,
      );

      if (isEdit && selectedCalendarId) {
        const q = query(
          collection(db, "Calendars"),
          where("CalendarID", "==", name),
        );
        const snapshot = await getDocs(q);
        if (
          !snapshot.empty &&
          snapshot.docs.some((doc) => doc.id !== selectedCalendarId)
        ) {
          setMessage("ERROR: Ya existe un calendario con ese nombre");
          setStatus("failure");
          return;
        }
        await updateDoc(doc(db, "Calendars", selectedCalendarId), {
          CalendarID: name,
          StartTime: fechaInicio,
          EndTime: fechaFin,
          WeekDays: weekDays,
          UnabledDays: cleanDays,
          UnabledSlots: cleanSlots,
        });
        navigate("/main", {
          state: {
            message: "Calendario actualizado correctamente",
            err: "success",
          },
        });
      } else {
        const q = query(
          collection(db, "Calendars"),
          where("CalendarID", "==", name),
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          setMessage("ERROR: Ya existe un calendario con ese nombre");
          setStatus("failure");
          return;
        }
        await addDoc(collection(db, "Calendars"), {
          CalendarID: name,
          StartTime: fechaInicio,
          EndTime: fechaFin,
          WeekDays: weekDays,
          UnabledDays: cleanDays,
          UnabledSlots: cleanSlots,
        });
        navigate("/main", {
          state: { message: "Calendario creado correctamente", err: "success" },
        });
      }
      setStatus("success");
      clearForm();
    } catch (error) {
      console.error(error);
      setMessage("ERROR al guardar el calendario");
      setStatus("failure");
    }
  };

  const deleteCalendar = async () => {
    if (!selectedCalendarId) return;
    try {
      await deleteDoc(doc(db, "Calendars", selectedCalendarId));
      clearForm();
      setStatus("success");
      navigate("/main", {
        state: {
          message: "Calendario eliminado correctamente",
          err: "success",
        },
      });
    } catch (error) {
      console.error(error);
      setMessage("ERROR al eliminar el calendario");
      setStatus("failure");
    }
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
  };

  // Festivos y slots
  const addFestivity = () => {
    const festivos = [].concat(UnabledDays);

    const hasEmpty = festivos.some(
      (uD) => !uD.Deleted && (!uD.Title || uD.Title.trim() === ""),
    );

    if (hasEmpty) return;

    festivos.push({
      id: "",
      Date: "",
      Title: "",
      Deleted: false,
    });

    setUnabledDays(festivos);

    setShowFestivityForm(true);
  };

  const addBloquedSlot = () => {
    const huecos = [].concat(UnabledSlots);
    if (
      !huecos.some((h) => !h.Deleted && !h.StartTime && !h.EndTime && !h.Why)
    ) {
      const now = new Date();
      huecos.push({
        id: "",
        StartTime: new Date(now.setHours(8, 0, 0, 0)), // 08:00 por defecto
        EndTime: new Date(now.setHours(9, 0, 0, 0)), // 09:00 por defecto
        Why: "",
        Deleted: false,
      });
      setUnabledSlots(huecos);
    }
    setSlotsForm(true);
  };

  const handleDelete = (id, index) => {
    if (id === "UnabledDay") {
      const uD = [...UnabledDays];
      uD[index].Deleted = true;
      setUnabledDays(uD);
    }
    if (id === "UnabledSlots") {
      const uS = [...UnabledSlots];
      uS[index].Deleted = true;
      setUnabledSlots(uS);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("es-ES", { month: "short" });
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <section>
        <div>
          <div>
            <Card className="bigSize">
              <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                {isEdit ? "Editar Calendario" : "Nuevo Calendario"}
              </h5>

              <form>
                <div>
                  <Label htmlFor="calendarName" value="Nombre del Calendario" />
                  <TextInput
                    id="calendarName"
                    placeholder="Nombre del Calendario"
                    list="calendarList"
                    value={name}
                    onChange={(e) => handleNameChange(e.target.value)}
                    required
                  />
                  {isEdit && (
                    <datalist id="calendarList">
                      {calendars.map((c) => (
                        <option key={c.id} value={c.CalendarID} />
                      ))}
                    </datalist>
                  )}
                </div>

                <div>
                  <Label htmlFor="startDate" value="Hora de Inicio" />
                  <TextInput
                    id="startDate"
                    type="time"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <Label htmlFor="endDate" value="Hora de Finalización" />
                  <TextInput
                    id="endDate"
                    type="time"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    required
                  />
                </div>

                {/* Festivos */}
                <div className="mb-2 block">
                  <h6 className="font-bold tracking-tight text-gray-900 dark:text-white formFontSize">
                    Festivos ({UnabledDays.filter((uD) => !uD.Deleted).length})
                  </h6>
                </div>
                <div className="innerFormDiv smallMarginTop">
                  {showFestivityForm && (
                    <Container>
                      <Row>
                        {UnabledDays.map((f, i) => (
                          <Col
                            sm={12}
                            key={"fest" + i}
                            className={`marginBot smallMarginTop ${
                              f.Deleted ? "displayNone" : ""
                            }`}
                          >
                            <Card>
                              <div>
                                <div>
                                  <div className="mb-2 block">
                                    <Label
                                      htmlFor="festivityName"
                                      value="Nombre de la Festividad"
                                    />
                                  </div>
                                  <TextInput
                                    placeholder="Nombre del Festivo"
                                    value={f.Title}
                                    onChange={(e) => {
                                      f.Title = e.target.value;
                                      setUnabledDays([...UnabledDays]);
                                    }}
                                    shadow
                                    type="text"
                                    className="formInputs"
                                    required
                                    contentEditable
                                  />
                                </div>
                                <div className="mb-1 block">
                                  <Label htmlFor="endDate" value="Fecha" />
                                </div>
                                <Datepicker
                                  value={
                                    f.Date
                                      ? formatDate(f.Date)
                                      : formatDate(new Date())
                                  }
                                  onSelectedDateChanged={(date) => {
                                    f.Date = date;
                                    setUnabledDays([...UnabledDays]);
                                  }}
                                  weekStart={2}
                                  language="es-ES"
                                />
                                <ButtonMui
                                  color="error"
                                  onClick={() => handleDelete("UnabledDay", i)}
                                >
                                  Cancelar
                                </ButtonMui>
                              </div>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  )}
                </div>
                <Button className="formBtn" onClick={addFestivity}>
                  Añadir Festivo
                </Button>

                {/* Slots */}
                <div className="mb-2 block">
                  <h6 className="font-bold tracking-tight text-gray-900 dark:text-white formFontSize">
                    Horas Bloqueadas (
                    {UnabledSlots.filter((uS) => !uS.Deleted).length})
                  </h6>
                </div>
                <div className="innerFormDiv smallMarginTop">
                  {showSlotsForm && (
                    <Container data={UnabledSlots}>
                      <Row>
                        {UnabledSlots.map((s, i) => (
                          <Col
                            sm={12}
                            key={"slot" + i}
                            className={`marginBot smallMarginTop ${
                              s.Deleted ? "displayNone" : ""
                            }`}
                          >
                            <Card>
                              <div>
                                <div>
                                  <div className="mb-2 block">
                                    <Label
                                      htmlFor="festivityName"
                                      value="Motivo del Bloqueo"
                                    />
                                  </div>
                                  <TextInput
                                    placeholder="Motivo del Bloqueo"
                                    value={s.Why}
                                    onChange={(e) => {
                                      s.Why = e.target.value;
                                      setUnabledSlots([...UnabledSlots]);
                                    }}
                                  />
                                </div>
                                <div className="mb-1 block">
                                  <Label
                                    htmlFor="startDate"
                                    value="Hora de Inicio"
                                  />
                                </div>
                                <TextInput
                                  id="startDate"
                                  placeholder="Hora de Inicio"
                                  type="time"
                                  value={
                                    s.StartTime
                                      ? s.StartTime.toLocaleTimeString(
                                          "es-ES",
                                          {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          },
                                        )
                                      : ""
                                  }
                                  onChange={(e) => {
                                    const [h, m] = e.target.value.split(":");
                                    s.StartTime.setHours(
                                      parseInt(h),
                                      parseInt(m),
                                    );
                                    setUnabledSlots([...UnabledSlots]);
                                  }}
                                  shadow
                                  className="formInputs"
                                  required
                                  contentEditable
                                />
                              </div>
                              <div className="mb-1 block">
                                <Label
                                  htmlFor="endDate"
                                  value="Hora de Finalización"
                                />
                              </div>
                              <TextInput
                                id="endDate"
                                placeholder="Hora de Finalización"
                                type="time"
                                value={
                                  s.EndTime
                                    ? s.EndTime.toLocaleTimeString("es-ES", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })
                                    : ""
                                }
                                onChange={(e) => {
                                  const [h, m] = e.target.value.split(":");
                                  s.EndTime.setHours(parseInt(h), parseInt(m));
                                  setUnabledSlots([...UnabledSlots]);
                                }}
                                shadow
                                className="formInputs"
                                required
                                contentEditable
                              />
                              <ButtonMui
                                color="error"
                                onClick={() => handleDelete("UnabledSlots", i)}
                              >
                                Cancelar
                              </ButtonMui>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  )}
                </div>
                <Button className="formBtn" onClick={addBloquedSlot}>
                  Añadir Horas Bloqueadas
                </Button>

                {/* Días de la semana */}
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="days" value="Días de la semana:" />
                  </div>
                  <div id="days" className="daysDiv">
                    <Checkbox
                      id="L"
                      checked={lunes}
                      onChange={(e) => setLunes(e.target.checked)}
                    />
                    <Label htmlFor="L" className="smallMarginLabel">
                      Lunes
                    </Label>

                    <Checkbox
                      id="M"
                      checked={martes}
                      onChange={(e) => setMartes(e.target.checked)}
                    />
                    <Label htmlFor="M" className="smallMarginLabel">
                      Martes
                    </Label>

                    <Checkbox
                      id="X"
                      checked={miercoles}
                      onChange={(e) => setMiercoles(e.target.checked)}
                    />
                    <Label htmlFor="X" className="smallMarginLabel">
                      Miercoles
                    </Label>

                    <Checkbox
                      id="J"
                      checked={jueves}
                      onChange={(e) => setJueves(e.target.checked)}
                    />
                    <Label htmlFor="J" className="smallMarginLabel">
                      Jueves
                    </Label>

                    <Checkbox
                      id="V"
                      checked={viernes}
                      onChange={(e) => setViernes(e.target.checked)}
                    />
                    <Label htmlFor="V" className="smallMarginLabel">
                      Viernes
                    </Label>

                    <Checkbox
                      id="S"
                      checked={sabado}
                      onChange={(e) => setSabado(e.target.checked)}
                    />
                    <Label htmlFor="S" className="smallMarginLabel">
                      Sabado
                    </Label>

                    <Checkbox
                      id="D"
                      checked={domingo}
                      onChange={(e) => setDomingo(e.target.checked)}
                    />
                    <Label htmlFor="D" className="smallMarginLabel">
                      Domingo
                    </Label>
                  </div>
                </div>

                {/* Botones Guardar / Eliminar */}
                <div className="flex gap-4 mt-4">
                  <Button className="formBtn marginTop" onClick={saveCalendar}>
                    {isEdit ? "Guardar Cambios" : "Guardar Calendario"}
                  </Button>
                  {isEdit && (
                    <Button
                      color="failure"
                      className="formBtn marginTop"
                      onClick={handleDeleteClick}
                    >
                      Eliminar Calendario
                    </Button>
                  )}
                </div>
                <Modal
                  show={showDeleteModal}
                  onClose={cancelDelete}
                  size="md"
                  popup
                >
                  <Modal.Header className="border-b-0" />
                  <Modal.Body>
                    <div className="text-center">
                      <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                        ¿Está seguro que desea eliminar este calendario?
                        <br />
                        Esta acción{" "}
                        <span className="font-bold text-red-600">
                          no se puede deshacer
                        </span>
                        .
                      </h3>
                      <div className="flex justify-center gap-4">
                        <Button color="failure" onClick={deleteCalendar}>
                          Eliminar
                        </Button>
                        <Button color="gray" onClick={cancelDelete}>
                          Cancelar
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </form>
            </Card>

            <div className="divToast mt-4">
              {status === "success" && <ToastMSG message={message} />}
              {status === "failure" && (
                <ToastErrMSG message={message} count={1} />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default function AddCalendar() {
  return sessionStorage.getItem("user") ? (
    <>
      <HeaderBar />
      <AddCalendarComponent />
    </>
  ) : (
    <Navigate replace to="/" />
  );
}
